var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-dec"},[_c('p',{staticClass:"dec-title"},[_vm._v("红云智汇")]),_c('p',{staticClass:"dec-desc"},[_vm._v("领先的组工信息化解决方案专家")])])
}]

export { render, staticRenderFns }